export default {
  name: "layout-breadcrumb-none"
};